export default __webpack_public_path__ + "static/media/1942.d3a1e21a.png";